// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"f4b96715","844":"bc906700"}[chunkId] + ".chunk.js";
};